import { getJSON } from "../helpers/core";

/**
 * Get bank holiday dates
 * @returns {Promise<*>}
 */
export const search = () => getJSON(`BankHolidays/Search`);
